import { styled } from 'stitches.config'

export const FAQRoot = styled('div', {
  background: '$accent-white',
  padding: '$6 $2',
  '@bp2': {
    padding: '$8 $4',
  },
})

export const FAQContainer = styled('div', {
  maxWidth: '900px',
  margin: '0 auto',
})

export const FAQTitle = styled('h2', {
  fontFamily: '$primary',
  fontSize: '$h4',
  lineHeight: '$h4',
  letterSpacing: '$h4',
  textAlign: 'center',
  marginBottom: '$5',

  '@bp2': {
    fontSize: '$h2',
    lineHeight: '$h2',
    letterSpacing: '$h2',
    textAlign: 'left',
    marginLeft: '8px',
  },
})

export const InformationWrapper = styled('div', {
  '& > div': {
    maxWidth: '900px'
  },
  '& div > button': {
    fontSize: '$body',
    lineHeight: '$body',
    letterSpacing: '$body',
    fontFamily: '$primary'
  },
  '& div': {
    fontSize: '$body ',
    lineHeight: '$body ',
    letterSpacing: '$body ',
  }

})